/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { Table } from "@tanstack/react-table";
import { FiltersInterface } from "config/consts";
import { useIsMobile } from "hooks/useDeviceType";
import { VariableSizeList as List } from "react-window";
import { NoFilterResultDisplay } from "../../pages/TradeHistory/elements/NoFilterResultDisplay";
import { TransactionDetail } from "../../types/history";
import { ActivityTableList } from "./elements/ActivityTableList";
import { TableRow } from "./elements/TableRow";
import { useEffect } from "react";

interface ActivityTableProps {
  table: Table<TransactionDetail>;
  confirmedFilters: FiltersInterface;
  clearAllFilters: () => void;
  virtualizedListRef: React.RefObject<List<typeof TableRow>>;
}

export const ActivityTable = ({
  table,
  confirmedFilters,
  clearAllFilters,
  virtualizedListRef,
}: ActivityTableProps) => {
  const isMobile = useIsMobile();
  const { rows } = table.getRowModel();
  const columns = table.getAllLeafColumns();
  useEffect(() => {
    // Hide timestamp column when below 1024
    if (window.innerWidth < 1024) {
      columns?.[0].toggleVisibility(false);
    } else {
      columns?.[0].toggleVisibility(true);
    }
  }, [columns]);

  if (table.getFilteredRowModel().rows.length === 0) {
    return (
      <NoResultContainer>
        <NoFilterResultDisplay clearAllFilters={clearAllFilters} />
      </NoResultContainer>
    );
  }

  return (
    <TableContainer isMobile={isMobile}>
      <ActivityTableList
        virtualizedListRef={virtualizedListRef}
        rows={rows}
        confirmedFilters={confirmedFilters}
      />
    </TableContainer>
  );
};

// Sub-components

const TableContainer = styled.div<{ isMobile: boolean }>`
  flex-grow: 1;
  height: ${props => (props.isMobile ? "89%" : "100%")};
  overflow-y: ${props => (props.isMobile ? "scroll" : "hidden")};
  overflow-x: hidden;
  scrollbar-width: thin;
  ::-webkit-scrollbar {
    width: 6px;
  }
`;

const NoResultContainer = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
`;
